import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { IonCard, IonCardContent } from '@ionic/angular/standalone';
import { DecaStoreService } from '../deca-store.service';

@Component({
  selector: 'lib-deca-counters-shipper',
  templateUrl: './deca-counters-shipper.component.html',
  styleUrls: ['./deca-counters-shipper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonCardContent, IonCard],
})
export class DecaCountersShipperComponent {
  private readonly decaStoreService = inject(DecaStoreService);

  protected readonly upcomingDocumentsAsShipperCount = computed(
    () => this.decaStoreService.upcomingDocumentsAsShipper().totalElements,
  );

  protected readonly pastDocumentsAsShipperCount = computed(
    () => this.decaStoreService.pastDocumentsAsShipper().totalElements,
  );

  protected readonly todayDocumentsAsShipperCount = computed(
    () => this.decaStoreService.todayDocumentsAsShipper().totalElements,
  );

  protected readonly nextDocumentsAsShipperCount = computed(
    () =>
      this.decaStoreService.upcomingDocumentsAsShipper().totalElements -
      this.decaStoreService.todayDocumentsAsShipper().totalElements,
  );
}
